import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calculator__stats-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_calculator_base_perk = _resolveComponent("calculator-base-perk")!
  const _component_calculator_skill = _resolveComponent("calculator-skill")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (
				_ctx.branchIndex === 0 && _ctx.branchTier === 'tier1' && _ctx.soldierClass !== 'custom'
			)
      ? (_openBlock(), _createBlock(_component_calculator_base_perk, {
          key: 0,
          soldierClass: _ctx.soldierClass
        }, null, 8, ["soldierClass"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tierSkills, (item, index) => {
      return (_openBlock(), _createBlock(_component_calculator_skill, {
        key: item,
        skill: _ctx.tierSkills[index],
        branchColor: _ctx.branchColor,
        tags: _ctx.tags,
        skillKey: index,
        branchRemainingStats: _ctx.branchRemainingStats,
        onStatChanged: _ctx.statChanged
      }, null, 8, ["skill", "branchColor", "tags", "skillKey", "branchRemainingStats", "onStatChanged"]))
    }), 128))
  ]))
}